exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".van-cell[data-v-17d39680]{font-size:17px}", ""]);

// exports
